export const ROLLOUT_STATUSES = ['draft', 'active', 'stopped', 'deleted', 'completed'];

export const ROLLOUT_SEGMENTATIONS = ['all', 'new', 'returning'];

export const STATUS_LABELS = {
  draft: 'Draft',
  active: 'Active',
  stopped: 'Stopped',
  deleted: 'Deleted',
  completed: 'Completed',
};

export const SEGMENTATION_LABELS = {
  all: 'All users',
  new: 'New users',
  returning: 'Returning users',
};

export const STATUS_DESCRIPTIONS = {
  draft: 'Rollout is being prepared. The game is visible in Admin but not included in arena Feed / SiteMap.',
  active: 'Rollout is running. The game is in the client feed with a rollout object (percentage 1–100).',
  stopped: 'Rollout is paused. The game stays in Feed / SiteMap with percentage 0 (no distribution; direct link still works).',
  deleted: 'Logical exclusion from client responses. The record is kept for history.',
  completed: 'Rollout finished. The game is in the feed for all users without rollout limitations.',
};

export const CHANGE_LOG_TABLE = 'feed_game_rollout_settings';

export function formatRolloutDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  const pad = (part) => String(part).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
